<script>
import { link } from 'svelte-spa-router'
import { FormValidator, InputValidator } from '../form.js';
import firebase from '../firebase';
import * as utils from '../utils';
import Header from './header.svelte';
import Button from './button.svelte';


let email = '';
let error = '';
let sending = false;

let emailSent = false;

const formValidator = FormValidator();

function Go()
{
    if ($formValidator !== 1)
        return; // form has errors

    sending = true;
    error = '';

    firebase.auth().sendPasswordResetEmail(email).then(() =>
    {
        emailSent = true;
    })
    .catch((e) =>
    {
        if (e.code === 'auth/user-not-found')
        {
            error = 'No account found with this email address';
        }
        else if (e.code === 'auth/invalid-email')
        {
            error = 'Please use a valid email address';
        }

        utils.log('Reset error', e);
        sending = false;
    });
}

</script>

<Header/>

<div class="container main medium" style="margin-top: 2.5em;">
    {#if emailSent}
    <section>
      <header class="line-after">
          <h3>Email Sent</h3>
      </header>
          <p>An email with instructions on how to reset your email has been sent to<br/><strong>{email}</strong>. Check your spam or junk folder if you don't see the email in your inbox</p>
          <p>If you no longer have acces to this email account,  <a href="/contact" use:link>contact support</a></p>
    </section>
    {:else}
    <section>
      <header class="line-after">
          <h3>Forgot Email/Password</h3>
      </header>
          <p>We will send you an email with instructions on how to reset your password.</p>
    </section>
    <section>
      <form on:submit|preventDefault={Go} novalidate>
          <div class="row gtr-uniform gtr-50">
              {#if error}
              <div class="col-12 col-12-xsmall">
                  <ul class="actions special">
                      <li class="error"><div>{error}</div></li>
                  </ul>
              </div>
              {/if}
              <div class="col-12 col-12-xsmall">
                  <input use:InputValidator={formValidator} type="email" placeholder="name@example.com" bind:value={email} />
                  <div class="errorMsg">Use a valid email address</div>
              </div>
              <div class="col-12 col-12-xsmall">
                  <ul class="actions special">
                      <li><Button state={sending ? 'loading': ''} class="primary fit button" text="Email Me"/></li>
                  </ul>
              </div>
          </div>
      </form>
      <p>If you don't remember you email, please <a href="/contact" use:link>contact support</a></p>
    </section>
    {/if}
</div>

<style>
    strong 
    {
        color: white;
    }
input[type="submit"] {
  background-color: rgb(0 0 0 / .3);
  box-shadow: none !important;
  color: #fff !important;
  width: 100%;
}

header.major { margin: 1em 0 0 0; }
header.line-after:after {
  content: '';
  display: inline-block;
  width: 100%;
  height: 0.25rem;
  margin: 0em 0 1.5em 0;
  border-radius: 4px;
  background-color: #4a98e2;
}

@media screen and (max-width: 480px) {
  .container > section.line-after:after {
    width: 100%;
    height: 0.25rem;
    margin: 1em 0;
  }
}

@media screen and (max-width: 736px) {
  .image > img {
    max-width: 90%;
    margin: 0 auto;
  }
}

form a
{
    color: rgb(103, 189, 255);
    border-bottom: 0;
}

input.error
{
    border-color: red;
    border-width: 2px;
}

.container.medium.main {
  background-color: #1a242f !important;
  padding-top: 0;
  font-size: 13pt;
}

.container.medium.main input {
    background-color: rgb(0 0 0 / .3);
}

.container.medium.main h4, .container.medium.main h6, input, label, h2, h3, p {
  color: #fff !important;
}

label {font-weight: 400;}

.container.medium.main {
  width: 500px;
  max-width: 500px;
}

@media screen and (max-width: 736px) {
  .container.medium.main {
    width: 425px;
  }
}

@media screen and (max-width: 480px) {
  .container.medium.main {
    width: 275px;
  }
}

@media screen and (max-width: 320px) {
  .container.medium.main {
    width: 250px;
  }
}


ul.actions.special >li { width: 100%; margin: 0;}


header p
{
    text-align: left;
}

input.error
{
    border-color: red;
}

li.error
{
    width: 100%;
    color: red;
}

.errorMsg
{
    padding-left:10px;
    display:none;
    color: red;
    text-align: left;
}

</style>
